/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/design/MbbQiNEkuiiLZSbZuPzyVD
 */
import { pickComponent } from './pickComponent.js';
export function getComponents({ prng, options, }) {
    var _a, _b, _c, _d, _e, _f;
    const shape2Component = pickComponent({
        prng,
        group: 'shape2',
        values: options.shape2,
        width: 150,
        height: 150,
        rotation: ((_a = options.shape2Rotation) === null || _a === void 0 ? void 0 : _a.length) ? options.shape2Rotation : [0],
        offsetX: ((_b = options.shape2OffsetX) === null || _b === void 0 ? void 0 : _b.length) ? options.shape2OffsetX : [0],
        offsetY: ((_c = options.shape2OffsetY) === null || _c === void 0 ? void 0 : _c.length) ? options.shape2OffsetY : [0],
    });
    const shape1Component = pickComponent({
        prng,
        group: 'shape1',
        values: options.shape1,
        width: 150,
        height: 150,
        rotation: ((_d = options.shape1Rotation) === null || _d === void 0 ? void 0 : _d.length) ? options.shape1Rotation : [0],
        offsetX: ((_e = options.shape1OffsetX) === null || _e === void 0 ? void 0 : _e.length) ? options.shape1OffsetX : [0],
        offsetY: ((_f = options.shape1OffsetY) === null || _f === void 0 ? void 0 : _f.length) ? options.shape1OffsetY : [0],
    });
    return {
        shape2: shape2Component,
        shape1: shape1Component,
    };
}
